import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  loading: boolean;
  success: boolean;
  error: string | null;
  backgroundColor?: string;
}

const initialState: AppState = {
  loading: false,
  success: false,
  error: null,
  backgroundColor: "bg-forest-950",
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setBackgroundColor: (state, action: PayloadAction<string | undefined>) => {
      state.backgroundColor = action.payload;
    },
  },
});

export const { 
  setLoading, 
  setSuccess, 
  setError,
  setBackgroundColor,
} = appSlice.actions;

export default appSlice.reducer;
